export const USER_IDLE_THRESHOLD = 25; // minutes
export const USER_IDLE_ALERT_THRESHOLD = 5; // minutes

export const SCHEDULE_EVENT_API_AVAILABLE = false;
